import { SearchableSelect } from '@/components/ui/SearchableSelect';
import { usePurchaseOrderSelectSearch } from '@/hooks/usePurchaseOrderSelectSearch';
import type { PurchaseOrderResponse } from '@/api/procurement.api';

export interface PurchaseOrderSelectProps {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  onOrderChange?: (order: PurchaseOrderResponse | null) => void;
  supplierId?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: string;
  name?: string;
}

/** Searchable purchase order picker — server search by PO number. */
export function PurchaseOrderSelect({
  label = 'Purchase order',
  value = '',
  onChange,
  onOrderChange,
  supplierId,
  placeholder = 'Search purchase order…',
  disabled,
  className,
  required,
  error,
  name,
}: PurchaseOrderSelectProps) {
  const { options, loading, searching, onSearchQuery, getPurchaseOrder } = usePurchaseOrderSelectSearch({
    value,
    supplierId,
  });

  const handleChange = (next: string) => {
    onChange?.(next);
    onOrderChange?.(next ? getPurchaseOrder(next) ?? null : null);
  };

  return (
    <SearchableSelect
      label={label}
      name={name}
      required={required}
      error={error}
      value={value}
      onChange={handleChange}
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      loading={loading}
      searching={searching}
      className={className}
      searchPlaceholder="Search by PO number…"
      emptyMessage="No purchase orders found"
      filterLocally={false}
      onSearchQuery={onSearchQuery}
    />
  );
}
